module.exports = __webpack_public_path__ + "img/74.8.TSS.e6328d61.png";